import { getScore } from "./getScore"

export const getTotalScore = (answers) => {


    let tempTotal = 0
    Object.values(answers).forEach((ans, id) => {

        if (id == 0) return   // this is to remove 5th qn as it is not included in scoring
        tempTotal = tempTotal + getScore(id, ans,)
    })
    return tempTotal

}